import axios from "utils/httpClient";
import React, { useState, useEffect } from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';
import HealingIcon from '@material-ui/icons/Healing';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import logo from 'logo.png';

const useStyles = makeStyles(styles);

export default function DBVaccine(props) {
    const VaccineEventKey = (props.match.params.VaccineEventKey !== undefined) ? props.match.params.VaccineEventKey : null;

    const [VaccineTotal, setVaccineTotal] = useState(0);
    const [VaccineDone, setVaccineDone] = useState(0);
    const [VaccineWait, setVaccineWait] = useState(0);
    const [VaccineScan, setVaccineScan] = useState(0);

    useEffect(() => {

        retriveDashboard();

        setInterval(() => {
            retriveDashboard();
        }, 10000);

    }, []);


    const retriveDashboard = () => {

        const requestOptions = {
            method: "GET",
        };


        axios("/api/vaccine/dashboard/" + VaccineEventKey, requestOptions)
            .then(response => response.data)
            .then(
                result => {
                    setVaccineTotal(result.total);
                    setVaccineDone(result.done);
                    setVaccineWait(result.wait);
                    setVaccineScan(result.scan);
                },
                error => {
                    alert(error);
                }
            );
    };


    const classes = useStyles();
    return (
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <CardIcon color="warning">
                                <SupervisorAccountIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>กลุ่มเป้าหมายทั้งหมด</p>
                            <h3 className={classes.cardTitle}>
                                {VaccineTotal} <small>คน</small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            {/* <div className={classes.stats}>
                <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  Get more space
                </a>
              </div> */}
                        </CardFooter>
                    </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <Card>
                        <CardHeader color="info" stats icon>
                            <CardIcon color="info">
                                <AddToQueueIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>ลงทะเบียนแล้ว</p>
                            <h3 className={classes.cardTitle}>
                                {VaccineDone} <small>คน</small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            {/* <div className={classes.stats}>
                <DateRange />
                Last 24 Hours
              </div> */}
                        </CardFooter>
                    </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={6} >
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <img style={{ width: "50px" }} src={logo} alt="Logo" />
                            </CardIcon>
                            <p className={classes.cardCategory}>บันทึก Serial</p>
                            <h3 className={classes.cardTitle}>
                                {VaccineScan} <small>คน</small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            {/* <div className={classes.stats}>
                <LocalOffer />
                Tracked from Github
              </div> */}
                        </CardFooter>
                    </Card>
                </GridItem>
  
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" stats icon>
                            <CardIcon color="primary">
                                <HourglassEmptyIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>รอฉีด</p>
                            <h3 className={classes.cardTitle}>
                                {VaccineWait} <small>คน</small>
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                            {/* <div className={classes.stats}>
                <Update />
                Just Updated
              </div> */}
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
